import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import Layout from '../components/Layout'
import SlidingProductTemplate from '../components/templates/SlidingProductTemplate'

const SlidingProduct = ({data}) => {
  const frontmatter = get(data, 'markdownRemark.frontmatter', {})
  return (
    <Layout frontmatter={frontmatter}>
      <SlidingProductTemplate
        image={frontmatter.image}
        primaryColor={frontmatter.primaryColor}
        tagText={frontmatter.tagText}
        header={frontmatter.header}
        text={frontmatter.text}
        buttonTextLeft={frontmatter.buttonTextLeft}
        buttonTextRight={frontmatter.buttonTextRight}
        link={frontmatter.link}
      />
    </Layout>
  )
}

export default SlidingProduct

export const pageQuery = graphql`
  query SlidingProductByID($id: String!) {
    markdownRemark(id: { eq: $id }) {
      id
      html
      frontmatter {
        templateKey
        title
        description
        favicon
        logo
        description
        image
        header
        tagText
        text
        buttonTextLeft
        buttonTextRight
        link
        primaryColor
      }
    }
  }
`